import React from 'react';
import DENTMedicalExaminationsAlertEvent from './DENTMedicalExaminationsAlertEvent';
import styles from './DENTMedicalExaminationsAlertEvents.module.scss';
import { UpcomingExaminationEvent } from '../../Interfaces/medicalExamination/UpcomingExaminationEvent.interface';

interface Props {
	events: UpcomingExaminationEvent[];
	selectedEvent?: UpcomingExaminationEvent;
	onSelectEvent: (event: UpcomingExaminationEvent) => void;
}

const DENTMedicalExaminationsAlertEvents = ({
	events,
	selectedEvent,
	onSelectEvent,
}: Props) => {
	return (
		<div className={styles.eventsList}>
			{events.map(event => (
				<DENTMedicalExaminationsAlertEvent
					key={event.id}
					event={event}
					onClick={() => onSelectEvent(event)}
					isSelected={selectedEvent?.id === event.id}
				/>
			))}
		</div>
	);
};

export default DENTMedicalExaminationsAlertEvents;
